import { Component, Input } from '@angular/core';
import { OrganisationServiceService } from '../../services/organisation-service.service';
import { CommonModule } from '@angular/common';
import { reportLocation } from '../../../environments/environment.development';
import Swal from 'sweetalert2';
import { ReportFile } from '../../../models/types';

@Component({
  selector: 'app-report-list',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './report-list.component.html',
  styleUrl: './report-list.component.scss'
})
export class ReportListComponent {

  reports: ReportFile[] = [];
  displayedReports: ReportFile[] = [];
  selectedFile: File | null = null;
  organisationID: number = 0;
  @Input() orgID: string = '';
  @Input() isAdmin: boolean = false;

  itemsToShow = 10;
  selectedFileName: string | null = null;
  reportsWithRaceData: ReportFile[] = [];
  displayedRaceData: ReportFile[] = [];

  constructor(private organisationService: OrganisationServiceService) { }

  ngOnInit() {
    this.organisationID = Number(this.orgID);
    this.getReports();
  }

  getReports() {
    this.organisationService.getReports(this.organisationID).subscribe((response) => {
      this.reports = response.reports.map((report: { storedFilename: any; }) => {
        return {
          ...report,
          fileUrl: `${reportLocation}/static/content/reports/${this.organisationID}/${report.storedFilename}`
        };
      });
      this.reportsWithRaceData = this.reports.filter(report => report.raceData === true);
      this.displayedRaceData = this.reportsWithRaceData.slice(0, this.itemsToShow);
      this.displayedReports = this.reports.filter(report => !report.raceData).slice(0, this.itemsToShow);
    });
  }

  loadMore() {
    this.itemsToShow += 10;
    this.displayedReports = this.reports.slice(0, this.itemsToShow);
    this.displayedRaceData = this.reportsWithRaceData.slice(0, this.itemsToShow);
  }

  hideExtra() {
    this.itemsToShow = 10;
    this.displayedReports = this.reports.slice(0, this.itemsToShow);
    this.displayedRaceData = this.reportsWithRaceData.slice(0, this.itemsToShow);
  }
  onFileSelected(event: any): void {
    if (event.target.files.length > 0) {
      this.selectedFile = event.target.files[0];
      this.selectedFileName = this.selectedFile?.name ?? null;

    }
  }
  
  uploadReport(raceData: boolean = false): void {
    console.log('Uploading report with raceData =', raceData);
    if (this.selectedFile) {
      this.organisationService.uploadReport(this.organisationID, this.selectedFile, raceData).subscribe(
        () => {
          this.getReports();
          this.selectedFile = null;
          this.selectedFileName = null;
          // Reset the file input field
          const fileInputs = document.querySelectorAll('input[type="file"]') as NodeListOf<HTMLInputElement>;
          fileInputs.forEach(input => input.value = '');
          Swal.fire('Uspeh', 'Uspešno ste naložili dokument!', 'success');
        },
        (error) => {
          console.error('Napaka pri nalaganju dokumenta:', error);
          Swal.fire('Napaka', 'Napaka pri nalaganju dokumenta. Dovoljena sta formata pdf in docx.', 'error');
        }
      );
    } else {
      Swal.fire('Napaka', 'Prosim izberite datoteko.', 'error');
    }
  }

  deleteReport(reportId: number): void {
    this.organisationService.deleteReport(reportId).subscribe(
      () => this.getReports(),
      (error) => console.error('Error deleting report:', error)
    );
  }
}
